import { useState } from 'react';
import { COLORS, INPUT_STYLE } from '../../constants/theme';

interface SaveTemplateFormProps {
  onSave: (name: string) => void;
  onCancel: () => void;
  saving: boolean;
}

export function SaveTemplateForm({ onSave, onCancel, saving }: SaveTemplateFormProps) {
  const [name, setName] = useState('');

  const handleSave = () => {
    if (!name.trim()) return;
    onSave(name.trim());
  };

  return (
    <div className="flex items-center gap-1">
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleSave()}
        placeholder="Template name"
        className="text-sm px-2 py-1 rounded w-36"
        style={{ ...INPUT_STYLE, border: `1px solid ${COLORS.inputBorder}` }}
        maxLength={24}
        autoFocus
      />
      <button
        onClick={handleSave}
        disabled={saving || !name.trim()}
        className="text-green-400 text-xs hover:text-green-300 disabled:opacity-40"
      >
        Save
      </button>
      <button
        onClick={onCancel}
        className="text-xs hover:opacity-80"
        style={{ color: COLORS.text.tertiary }}
      >
        Cancel
      </button>
    </div>
  );
}
